export const MsgStatus = [
  {
    label: '待办',
    value: 0,
    color: '#1664FF',
  },
  {
    label: '完成',
    value: 1,
    color: '#16CF91',
  },
  {
    label: '逾期',
    value: 2,
    color: '#F53F3F',
  },
]
